(function () {
  'use strict';

  if (window.__ddHelpDrawerInit) return;
  window.__ddHelpDrawerInit = true;

  // ── Open / Close ─────────────────────────────────────────────────────────
  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  // ── Teleport + wire click-outside ────────────────────────────────────────
  // position:fixed breaks when any ancestor has a CSS transform (common in Dawn).
  // Moving overlays to <body> fixes that.  We also attach the click-outside
  // listener here — more reliable than relying on the backdrop data attribute
  // propagating through pointer-events layers.
  function initOverlay(overlay) {
    // Teleport to body so position:fixed covers the real viewport
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }

    // Click anywhere outside .dd-hd-panel → close
    if (!overlay._hdClickOutsideBound) {
      overlay.addEventListener('click', function (e) {
        if (!e.target.closest('.dd-hd-panel')) {
          closeDrawer(overlay.id);
        }
      });
      overlay._hdClickOutsideBound = true;
    }
  }

  function teleportOverlays() {
    document.querySelectorAll('.dd-hd-overlay').forEach(initOverlay);
  }

  // ── Global event delegation (open triggers, close buttons) ───────────────
  document.addEventListener('click', function (e) {
    // [data-hd-open="id"] → open a specific drawer by ID
    var opener = e.target.closest('[data-hd-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-hd-open'));
      return;
    }
    // [data-hd-open-drawer] → open the first drawer on the page (no ID needed)
    // Use this from external sections so the ID never needs to be hard-coded.
    var genericOpener = e.target.closest('[data-hd-open-drawer]');
    if (genericOpener) {
      e.preventDefault();
      var firstDrawer = document.querySelector('.dd-hd-overlay');
      if (firstDrawer) openDrawer(firstDrawer.id);
      return;
    }
    // [data-hd-close] → close button inside the panel
    var closer = e.target.closest('[data-hd-close]');
    if (closer) {
      closeDrawer(closer.getAttribute('data-hd-close'));
      return;
    }
  });

  // Escape key closes any open drawer
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('.dd-hd-overlay.is-open').forEach(function (el) {
        closeDrawer(el.id);
      });
    }
  });

  // ── Init ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', teleportOverlays);
  } else {
    teleportOverlays();
  }
})();
